import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import {
  BarChart as BarChartIcon,
  Edit as EditIcon,
  Image as ImageIcon,
} from "@mui/icons-material";
import DashboardLayout from "../components/DashboardLayout";
import DashboardCard from "../components/DashboardCard";
import ActivitiesForm from "../components/ActivitiesForm";
import VisitorCounting from "../components/VisitorCounting";
import PopupPictureUpload from "../components/PopupPictureUpload";

function Dashboard() {
  const [activeSection, setActiveSection] = useState("overview");

  // Dashboard Overview Stats Component
  const DashboardOverview = () => (
    <Box>
      <Typography variant="h4" gutterBottom fontWeight={600} sx={{ mb: 4 }}>
        Dashboard Overview
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%', cursor: 'pointer' }} onClick={() => setActiveSection("analytics")}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <BarChartIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                <Typography variant="h6" fontWeight={600}>
                  Visitor Analytics
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                View and manage website visitor statistics, charts, and historical data.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%', cursor: 'pointer' }} onClick={() => setActiveSection("activities")}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <EditIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                <Typography variant="h6" fontWeight={600}>
                  Edit Activities
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                Create and edit activities content with live preview and styling options.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%', cursor: 'pointer' }} onClick={() => setActiveSection("images")}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <ImageIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                <Typography variant="h6" fontWeight={600}>
                  Upload Images
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                Manage popup images with preview, upload, and delete capabilities.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mb: 3 }}>
          Quick Stats
        </Typography>
        <VisitorCounting />
      </Box>
    </Box>
  );

  // Render content based on active section
  const renderContent = () => {
    switch (activeSection) {
      case "overview":
        return <DashboardOverview />;
      case "analytics":
        return (
          <Box>
            <Typography variant="h4" gutterBottom fontWeight={600} sx={{ mb: 4 }}>
              Visitor Analytics
            </Typography>
            <VisitorCounting />
          </Box>
        );
      case "activities":
        return (
          <Box>
            <Typography variant="h4" gutterBottom fontWeight={600} sx={{ mb: 4 }}>
              Edit Activities Content
            </Typography>
            <ActivitiesForm />
          </Box>
        );
      case "images":
        return (
          <Box>
            <Typography variant="h4" gutterBottom fontWeight={600} sx={{ mb: 4 }}>
              Popup Image Management
            </Typography>
            <DashboardCard title="Popup Image Management" icon={<ImageIcon />}>
              <PopupPictureUpload />
            </DashboardCard>
          </Box>
        );
      default:
        return <DashboardOverview />;
    }
  };

  return (
    <>
      <Helmet>
        <title>Dashboard | London House</title>
      </Helmet>
      <DashboardLayout activeSection={activeSection} onSectionChange={setActiveSection}>
        {renderContent()}
      </DashboardLayout>
    </>
  );
}

export default Dashboard;